import { useAccount } from '@lib/context/account-context'

interface ProductPurchasableGateProps {
  productRestrictionData: ProductRestrictionData
  displayMessage?: boolean
  messageSize?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p'
  children: React.ReactNode
}

function ProductPurchasableGate({
  productRestrictionData,
  displayMessage = false,
  messageSize = 'p',
  children,
}: ProductPurchasableGateProps) {
  const { productVisibilityGroups } = useAccount()

  function isProductPurchasable() {
    if (
      !productRestrictionData ||
      !productRestrictionData.productVisibilityGroups
    ) {
      return true
    }

    // If product has no visibility groups, it is purchasable
    if (productRestrictionData.productVisibilityGroups.length === 0) {
      return true
    }

    // Otherwise, check if the customer has access to any of the product's visibility groups
    return productVisibilityGroups.some((group) => {
      return productRestrictionData.productVisibilityGroups?.includes(group.id)
    })
  }

  const productPurchasable = isProductPurchasable()

  const message = (
    <h3 className={`text-${messageSize} bg-yellow-100 p-1 rounded-lg`}>
      Product Not Available: Call for more information!
    </h3>
  )

  return <>{productPurchasable ? children : displayMessage ? message : <></>}</>
}

export default ProductPurchasableGate
